import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getProfile } from 'services/AuthService'
import { useAuthQuery } from 'hooks/useAuthQuery'

export const useProfileQuery = () => {
  const { isQueryAllowed, onHandleError } = useAuthQuery()

  return useQuery(reactQueryKeys.profile(), getProfile, {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: isQueryAllowed,
    onError: (error: unknown) => {
      onHandleError('Error: useProfileQuery', error)
    },
  })
}
